import React, { useEffect } from 'react'
import {
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Slider
} from '@material-ui/core'
import {
  Visibility,
  Delete,
  DragIndicatorRounded,
  ArrowDropDownCircleRounded,
  PlayCircleFilled
} from '@material-ui/icons'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import {
  useGlobalContext,
  layerVisibilityChanged,
  layerDeleted,
  layerSliderChanged,
  getLanguage
} from '../../state'
import { useMapEngine } from '../shared'
import { MAP_ID } from '../../utils/apiHelper'

import { useStyles } from './styles'

export const SelectedLayer = (props) => {
  const { dispatch } = useGlobalContext()
  const {
    id,
    isVisible,
    name,
    description,
    params,
    opacity,
    dragProvided,
    nameLegendGraphi
  } = props
  const classes = useStyles()
  const [engine] = useMapEngine(MAP_ID)

  useEffect(() => {
    if (engine) {
      engine.setLayoutProperty(id, 'visibility', isVisible ? 'visible' : 'none')
    }
  }, [id, isVisible, engine])

  // TODO: change inlinestyle to makestyles
  return (
    <Accordion expanded={isVisible} style={{ margin: 5 }}>
      <AccordionSummary
        style={{
          cursor: 'default',
          backgroundColor: 'white',
          width: '100%'
        }}
      >
        <Box>
          <Box>
            <IconButton
              onClick={() =>
                dispatch(layerVisibilityChanged({ id, isVisible: !isVisible }))
              }
            >
              {isVisible ? (
                <PlayCircleFilled className={classes.icon} />
              ) : (
                <ArrowDropDownCircleRounded className={classes.icon} />
              )}
            </IconButton>
            <IconButton
              onClick={() => {
                dispatch(layerVisibilityChanged({ id, isVisible: false }))
                setTimeout(() => dispatch(layerDeleted({ id })), 0)
              }}
              aria-label="Delete"
            >
              <Delete className={classes.icon} />
            </IconButton>

            {/* This prop allows dragging from a child component */}
            <IconButton
              aria-label="DragIndicatorRounded"
              {...dragProvided.dragHandleProps}
            >
              <DragIndicatorRounded className={classes.icon} />
            </IconButton>
          </Box>
          <Box>
            <Typography variant="h6">{name}</Typography>
            <Typography variant="subtitle1">{description}</Typography>
            {params.map(({ dimensionName: paramName, value }, index) => (
              <Box
                key={index}
                style={{
                  display: 'flex',
                  justifyContent: 'left'
                }}
              >
                <Typography variant="body1">
                  {paramName}
                  :&nbsp;
                </Typography>
                <Typography variant="body1">{value}</Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </AccordionSummary>
      <AccordionDetails className={classes.accordionDetailsContainer}>
        <Box className={classes.imgContainer}>
          <img
            alt="Legend Graph"
            // eslint-disable-next-line max-len
            src={`https://geoportal.cepal.org/geoserver/ows?service=WMS&request=GetLegendGraphic&format=image/png&LANGUAGE=${getLanguage()}&WIDTH=20&HEIGHT=20&LAYER=${nameLegendGraphi}&STYLE=${nameLegendGraphi}&legend_options=fontAntiAliasing:true;fontSize:12;forceLabels:on`}
          />
        </Box>
        <Box className={classes.sliderContainer}>
          <Slider
            min={0}
            max={100}
            value={opacity}
            valueLabelDisplay="auto"
            onChange={(_, newValue) =>
              dispatch(layerSliderChanged({ id, opacity: newValue }))
            }
          />
          <Visibility className={classes.icon} />
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}
